import React, {Component} from 'react';
import { Table } from 'semantic-ui-react'
import _ from 'lodash'
//import TestData from './data'
import UserFilter from '../UserFilter'
import TableFilter from '../TableFilter'
import CommesseComboFilter from '../CommesseComboFilter'
import ErrorMessage from '../ErrorMessage'
import {client} from '../../Client';
import DataFilter from '../DataFilter'
import PrintButton from '../PrintButton'
import ElaboraButton from '../ElaboraButton'
import LocalDate from '../LocalDate'
import {minutesToHuman} from '../../Helpers'
import FileSaver from 'file-saver';
import PdfButton from '../PdfButton'
import AttivitaPerCommessa from '../../pdf/AttivitaPerCommessa'
import Moment from 'moment';
import PropTypes from 'prop-types';
import { Checkbox } from 'semantic-ui-react'
import AttivitaPerAnno from "../../pdf/AttivitaPerAnno";
import {Bar} from 'react-chartjs-2';


class ReportAttivitaCommessaUtente extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: undefined,
            barData: {},
            filterInfo: {
                idUtente: client.getCurrentUserId(),
                idCommessa: 0,
                tipo: 'i',
            },
            _loading: false,
            error: null,
            column: null,
            direction: null,
            tipoReport2: false, // 1: report attività; 2: report attività annuale
        };
        this.onChangeUserFilter = this.onChangeUserFilter.bind(this)
        this.onChangeCommessaFilter = this.onChangeCommessaFilter.bind(this)
        this.onChangeData = this.onChangeData.bind(this)
        this.onChangeFilter = this.onChangeFilter.bind(this)
        this.onTipoChange = this.onTipoChange.bind(this)

        this.createTableDataAttivita = this.createTableDataAttivita.bind(this)
        this.onExportAttivitaClick = this.onExportAttivitaClick.bind(this)
        this.pdfExportAttivita = this.pdfExportAttivita.bind(this)
        this.loadDataAttivita = this.loadDataAttivita.bind(this)

        this.createTableDataAttivitaAnnuale = this.createTableDataAttivitaAnnuale.bind(this)
        this.onExportAttivitaAnnualeClick = this.onExportAttivitaAnnualeClick.bind(this)
        this.pdfExportAttivitaAnnuale = this.pdfExportAttivitaAnnuale.bind(this)
        this.loadDataAttivitaAnnuale = this.loadDataAttivitaAnnuale.bind(this)
    }


    getFilterDescription(){
        let msg = '';
        msg += 'Periodo dal ' + Moment(this.state.filterInfo.dataStart).format('DD/MM/YYYY') +
            ' al ' + Moment(this.state.filterInfo.dataEnd).format('DD/MM/YYYY');
        msg += ' Utenti: ' + this.state.filterInfo.nomeUtente;
        msg += ' Commesse: ' + this.state.filterInfo.nomeCommessa;
        return msg;
    }
    componentWillUnmount() {
    }

    componentDidMount() {
    }

    onChangeUserFilter(idutente, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.idUtente = idutente;
        filterInfo.nomeUtente = nome;
        this.setState({filterInfo: filterInfo, items:undefined})
    }
    onChangeCommessaFilter(idcommessa, nome){
        let filterInfo = this.state.filterInfo;
        filterInfo.idCommessa = idcommessa;
        filterInfo.nomeCommessa = nome;
        this.setState({filterInfo: filterInfo, items:undefined})
    }
    onChangeData(tipo, dataDal, dataAl){
        let filter = this.state.filterInfo;
        filter.dataStart = dataDal !== '' ? dataDal : undefined;
        filter.dataEnd = dataAl !== '' ? dataAl : undefined;
        filter.tipo = tipo;
        this.setState({filterInfo: filter, items:undefined})
    }
    onChangeFilter(data) {
        let filter = this.state.filterInfo;
        filter.keyword = data.keyword;
        this.setState({filterInfo: filter, items: undefined})
    }
    onTipoChange(a1, {name, checked}){
        this.setState({tipoReport2: checked, items: undefined})
    }

    handleSort = clickedColumn => () => {
        const { column, items, direction } = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                items: _.sortBy(items, [clickedColumn]),
                direction: 'ascending',
            })

            return
        }

        this.setState({
            items: items.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    }

    pdfExportAttivita(){
        let ce = new AttivitaPerCommessa();
        ce.setTitle("Report Commessa Utente");
        ce.setFileName("report_commessa_utente.pdf");
        ce.setOrientationPortrait();
        ce.setFilterDescription(this.getFilterDescription());
        ce.createPdf(this.state.items);
    }

    pdfExportAttivitaAnnuale(){
        let ce = new AttivitaPerAnno();
        ce.setTitle("Report Commessa Utente con Somma dei Tempi");
        ce.setFileName("report_commessa_utente_con_somma_tempi.pdf");
        ce.setOrientationPortrait();
        ce.setFilterDescription(this.getFilterDescription());
        ce.createPdf(this.state.items);
    }

    /**
     *
     * @param items
     * @returns {{labels: Array, datasets: [*]}}
     */
    createBarData(items)
    {
        let labels = [];
        let datas = [];
        let colors = [];
        for(let i=0; i<items.length; i++){

            labels.push(items[i].commessa.nomeCompleto);
            datas.push(items[i].durataPesata);
            colors.push(items[i].commessa.colore);
        }

        const data = {
            labels: labels,
            datasets: [{
                label: '',
                data: datas,
                borderWidth: 1,
                backgroundColor: colors,
                hoverBackgroundColor: colors,
            }]
        };
        return data;
    }

    loadDataAttivita() {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportAttivita(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd, filterInfo.idCommessa,
            filterInfo.keyword
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        total: data.total,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    loadDataAttivitaAnnuale() {

        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.loadReportAttivitaAnnuale(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd,  filterInfo.idCommessa,
            filterInfo.keyword
        ).then((response) => {
            if (response.ok)
            {
                response.json().then((data)=>{
                    this.setState({
                        items: data.items,
                        barData: this.createBarData(data.items),
                        total: data.total,
                        filterInfo: filterInfo,
                        _loading: false,
                        error: null
                    })
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((data) => {
                    this.setState({
                        _loading: false,
                        error: {title: data.title, msg: data.msg}
                    })
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message}
            })
        });
    }

    onExportAttivitaClick(tipo){
        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.exportReportAttivita(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd, filterInfo.idCommessa, tipo, filterInfo.keyword
        ).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'report_commessa_utente.'+tipo);
                })
            }
            else if (response.status === 401)
            {
                this.context.router.transitionTo("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    onExportAttivitaAnnualeClick(tipo){
        let filterInfo = this.state.filterInfo;
        this.setState({_loading: true});
        client.exportReportAttivitaAnnuale(
            filterInfo.idUtente, filterInfo.dataStart, filterInfo.dataEnd, filterInfo.idCommessa, tipo,filterInfo.keyword
        ).then((response) => {
            if (response.ok){
                response.blob().then((blob) => {
                    this.setState({_loading: false, error: null})
                    FileSaver.saveAs(blob, 'report_commessa_utente_con_somma_dei_tempi.'+tipo);
                })
            }
            else if (response.status === 401)
            {
                this.props.history.push("/login")
            }
            else
            {
                response.json().then((errore) => {
                    this.setState({
                        _loading: false,
                        error: {title: errore.title, msg: errore.msg},
                    });
                })
            }
        }).catch((error) => {
            this.setState({
                _loading: false,
                error: {title: "Errore di rete imprevisto", msg: error.message},
            });
        });
    }

    render() {

        if (this.state.error !== null)
        {
            return (<ErrorMessage title={this.state.error.title} msg={this.state.error.msg} onDismiss={()=>{this.setState({error:null})}}/>)
        }
        let loader = '';
        if  (this.state._loading) {
            loader = (
                <div className="ui active inverted dimmer">
                <div className="ui loader"></div>
                </div>
            );
        }
        let tableData = null;
        let stampaButton = null;
        let exportExcelButton = null;
        let exportPdfButton = null;

        if (!this.state.tipoReport2){
            let rv = this.createTableDataAttivita();
            tableData = rv.tableData;
            stampaButton = rv.stampaButton;
            exportExcelButton = rv.exportExcelButton;
            exportPdfButton = rv.exportPdfButton;
        }
        else{
            let rv = this.createTableDataAttivitaAnnuale();
            tableData = rv.tableData;
            stampaButton = rv.stampaButton;
            exportExcelButton = rv.exportExcelButton;
            exportPdfButton = rv.exportPdfButton;
        }


        return (<div className="ui">
            <h3 className="ui top block attached header no-print">
                <i className="clock icon"/> Report Commessa/Utente
            </h3>
            <div className="ui attached segment no-print">
            <div className="ui one column stackable grid">
                <div className="ui two column grid">
                    <div className="ten wide column">
                        <DataFilter
                            showOption={'specs'}
                            tipo={this.state.filterInfo.tipo}
                            dataDal={this.state.filterInfo.dataStart}
                            dataAl={this.state.filterInfo.dataEnd}
                            fireOnChangeOnStart={true}
                            onChange={this.onChangeData}
                        />
                    </div>
                    <div  className="six wide column">
                        <TableFilter
                            showPopup={true}
                            changeEventOnKeyPress={true}
                            value={this.state.filterInfo.keyword}
                            placeholder="Filtra attività per nota..."
                            onChangeFilter={this.onChangeFilter} />
                    </div>
                </div>
                <div className="column">
                    <div className="ui two column grid">
                        <div className="twelve wide  column">
                            <div className="ui three column grid">
                                <div className="column">
                                    <UserFilter
                                        idUtente={this.state.filterInfo.idUtente}
                                        abilitato={client.isCurrentUserAdmin()}
                                        onChange={this.onChangeUserFilter}
                                        dataDal={this.state.filterInfo.dataStart}
                                        dataAl={this.state.filterInfo.dataEnd}
                                    />
                                </div>
                                <div className="column">
                                    <CommesseComboFilter
                                        idCommessa={this.state.filterInfo.idCommessa}
                                        abilitato={true}
                                        onChange={this.onChangeCommessaFilter}
                                        dataDal={this.state.filterInfo.dataStart}
                                        dataAl={this.state.filterInfo.dataEnd}
                                        idUtente={this.state.filterInfo.idUtente}
                                    />
                                </div>
                                <div className="column">
                                    <Checkbox label="Con somma dei tempi e grafico" name="tipoReport" toggle checked={this.state.tipoReport2} onChange={this.onTipoChange} />
                                </div>
                            </div>
                        </div>
                        <div className="four wide  column">
                            {this.state.tipoReport2 ? <ElaboraButton text="Elabora" onClick={this.loadDataAttivitaAnnuale} /> : <ElaboraButton text="Elabora" onClick={this.loadDataAttivita} />}
                            {stampaButton} {exportExcelButton} {exportPdfButton}
                        </div>
                    </div>
                </div>
            </div>
            </div>

            {tableData}
            {loader}
        </div>)
    }

    createTableDataAttivita() {
        let i = 1;
        let numAttivitaTot = 0;
        let durataPesataTot = 0;
        let tableData = null;
        let stampaButton = null;
        let exportExcelButton = null;
        let exportPdfButton = null;
        if (this.state.items !== undefined) {
            if (this.state.items.length > 0) {
                stampaButton = <PrintButton/>
                exportExcelButton = (<a href="#" onClick={(ev) => (this.onExportAttivitaClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Excel
                    </div>
                </a>)
                exportPdfButton = (<PdfButton onClick={(ev) => (this.pdfExportAttivita())}/>)
                tableData = (
                    <div className="ui segment">
                        <h4>Report Commessa/Utente</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate
                            data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell
                                        sorted={this.state.column === 'idCommessa.nome' ? this.state.direction : null}>
                                        Commessa
                                    </Table.HeaderCell>
                                    <Table.HeaderCell
                                        sorted={this.state.column === 'idUtente.nome' ? this.state.direction : null}>
                                        Utente
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center'
                                                      sorted={this.state.column === 'numAttivita' ? this.state.direction : null}>
                                        Numero Sessioni
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center'
                                                      sorted={this.state.column === 'durataPesata' ? this.state.direction : null}>
                                        Durata Totale (h:m:s)
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    this.state.items.map((item) => {
                                        numAttivitaTot += item.numAttivita;
                                        durataPesataTot += item.durataPesata;
                                        return <Table.Row key={i++}>
                                            <Table.Cell><label className="ui empty circular label"
                                                               style={{backgroundColor: item.commessa.colore}}></label> {item.commessa.nomeCompleto}
                                            </Table.Cell>
                                            <Table.Cell>{item.utente.username}</Table.Cell>
                                            <Table.Cell textAlign='center'>{item.numAttivita}</Table.Cell>
                                            <Table.Cell
                                                textAlign='center'>{minutesToHuman(item.durataPesata)}</Table.Cell>
                                        </Table.Row>
                                    })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="2">Totali</Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center'><b>{numAttivitaTot}</b></Table.HeaderCell>
                                    <Table.HeaderCell
                                        textAlign='center'><b>{minutesToHuman(durataPesataTot)}</b></Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>
                    </div>
                )
            }
            else {
                tableData = (
                    <div className="ui segment">
                        <h4>Riepilogo Numero Attività e Durata per Commessa ed Utente</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate
                            data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        <Table celled>
                            <Table.Body>
                                <Table.Row key={1}>
                                    <Table.Cell><h4>Nessun dato disponibile</h4></Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                            </Table.Footer>
                        </Table>

                    </div>
                )
            }
        }
        return {tableData, stampaButton, exportExcelButton, exportPdfButton};
    }

    createTableDataAttivitaAnnuale() {
        let i = 1;
        let numAttivitaTot = 0;
        let durataPesataTot = 0;
        let tableData = null;
        let barChart = null;
        let stampaButton = null;
        let exportExcelButton = null;
        let exportPdfButton = null;

        if (this.state.items !== undefined){
            if (this.state.items.length > 0){
                stampaButton = <PrintButton/>
                exportExcelButton = (<a href="#" onClick={(ev) => (this.onExportAttivitaAnnualeClick('xlsx'))}>
                    <div className="ui left floated small primary labeled icon button">
                        <i className="file excel outline icon"></i> Esporta
                    </div>
                </a>)
                exportPdfButton = (<PdfButton onClick={(ev) => (this.pdfExportAttivitaAnnuale())} />)
                barChart = (
                    <Bar
                        data={this.state.barData}
                        options={{legend: {display: false}, scales: {
                                yAxes: [{
                                    ticks: {
                                        // Create scientific notation labels
                                        callback: function(value, index, values) {
                                            return minutesToHuman(value) + " (" + value + " minuti)";
                                        }
                                    }
                                }],
                                xAxes: [{
                                    ticks: {
                                        autoSkip: false
                                    }
                                }]
                            }}}/>
                )
                tableData = (
                    <div className="ui segment">
                        <h4>Report Commessa/Utente con somma dei tempi degli utenti</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        {barChart}
                        <Table celled>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell sorted={this.state.column === 'idCommessa.nome' ? this.state.direction:null} >
                                        Commessa
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'numAttivita' ? this.state.direction:null} >
                                        Numero Sessioni
                                    </Table.HeaderCell>
                                    <Table.HeaderCell textAlign='center' sorted={this.state.column === 'durataPesata' ? this.state.direction:null} >
                                        Durata Totale (h:m:s)
                                    </Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {
                                    this.state.items.map((item) => {

                                        numAttivitaTot += item.numAttivita;
                                        durataPesataTot += item.durataPesata;
                                        return <Table.Row key={i++}>
                                            <Table.Cell><label className="ui empty circular label" style={{backgroundColor: item.commessa.colore}}></label> {item.commessa.nomeCompleto}</Table.Cell>
                                            <Table.Cell  textAlign='center'>{item.numAttivita}</Table.Cell>
                                            <Table.Cell  textAlign='center'>{minutesToHuman(item.durataPesata)}</Table.Cell>
                                        </Table.Row>
                                    })}
                            </Table.Body>
                            <Table.Footer>
                                <Table.Row>
                                    <Table.HeaderCell>Totali</Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b>{numAttivitaTot}</b></Table.HeaderCell>
                                    <Table.HeaderCell  textAlign='center'><b>{minutesToHuman(durataPesataTot)}</b></Table.HeaderCell>
                                </Table.Row>
                            </Table.Footer>
                        </Table>

                    </div>
                )
            }
            else {
                tableData = (
                    <div className="ui segment">
                        <h4>Tempo totale Speso per Commessa</h4>
                        <p>
                            Periodo dal <b><LocalDate data={this.state.filterInfo.dataStart}/></b> al <b><LocalDate data={this.state.filterInfo.dataEnd}/></b>;
                            Utenti: <b>{this.state.filterInfo.nomeUtente}</b>;
                            Commesse: <b>{this.state.filterInfo.nomeCommessa}</b>;
                        </p>
                        <Table celled>
                            <Table.Body>
                                <Table.Row key={1}>
                                    <Table.Cell><h4>Nessun dato disponibile</h4></Table.Cell>
                                </Table.Row>
                            </Table.Body>
                            <Table.Footer>
                            </Table.Footer>
                        </Table>

                    </div>
                )
            }
        }
        return {tableData, stampaButton, exportExcelButton, exportPdfButton};
    }
}

ReportAttivitaCommessaUtente.contextTypes = {
    router: PropTypes.object
}

export default ReportAttivitaCommessaUtente;




/** WEBPACK FOOTER **
 ** ./src/components/report/ReportAttivitaCommessaUtente.js
 **/